import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CalendarComponentOptions } from 'ion2-calendar';
import * as moment from 'moment'
import {LocacionesService} from '../locaciones.service'
import { IonicSelectableComponent } from 'ionic-selectable';
import {GranServicioDePTWService}from '../gran-servicio-de-ptw.service'
import * as firebase from 'firebase'
import {AuthGuardService} from '../services/auth-guard.service'
import {ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'
import {TimelineComponent} from '../timeline/timeline.component'




//ionic-selectable
class Pozo{
  public id: number;
  public name: string;
  public regional: string;
}

//ionic-selectable
class Empresa{
  public id: number;
  public name: string;
  public dominio: string;
}

@Component({
  selector: 'app-paso1page',
  templateUrl: './paso1page.page.html',
  styleUrls: ['./paso1page.page.scss'],
})
export class Paso1pagePage implements OnInit {

    //ionic-selectable
    pozos: Pozo[];
    pozo: Pozo;

     //ionic-selectable
     empresas: Empresa[];
     empresa: Empresa;

 horarioDeTrabajo=''   
 fechainicio='';
 fechafinal='';
 
//  dateRange= { from: undefined, to: undefined };
dateRange= { from: undefined, to: undefined };
 type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
 optionsRange: CalendarComponentOptions = {
   pickMode: 'range'
 };

 dateInput:any
 diasSolicitados=1
 cuenca='';
 pozoSeleccionado=''
 empresaSeleccionada=''
 solicitanteGTE=''
 status=''
 arrayActividadesPTW=[]
 

 constructor(public locacionesService:LocacionesService, public granServicioDePTWService:GranServicioDePTWService,private router:Router,  public routeGuard: AuthGuardService, public serviciodealertasyloaders: ServicioLoadersAlertasService,public timelineComponent:TimelineComponent) { }

 

 ngOnInit() {
  this.cargaempresas()
 }
 ionViewWillEnter(){
 
  this.timelineComponent.actualizar()
   this.dateRange={from:undefined, to:undefined}

   if(this.granServicioDePTWService.solicitudEsNueva==false){

    
    
    firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).get().then((doc)=>{

      console.log(doc.data().fechafinal )
      console.log(doc.data().fechainicio )

      let dias = this.calcularDiferenciaDias(doc.data().fechafinal,doc.data().fechainicio )
      console.log(dias)


        this.empresaSeleccionada=doc.data().empresa
        this.horarioDeTrabajo=doc.data().horarioDeTrabajo;
        this.fechainicio=doc.data().fechainicio;
        this.fechafinal=doc.data().fechafinal;
      
        this.cuenca=doc.data().cuenca;
        this.pozoSeleccionado=doc.data().pozoSeleccionado;
        this.status=doc.data().status;
        this.diasSolicitados = this.calcularDiferenciaDias(doc.data().fechafinal,doc.data().fechainicio )

        if(doc.data().solicitanteGTE != undefined){
          this.solicitanteGTE = doc.data().solicitanteGTE
        }
        // this.dateRange.from= moment(this.fechainicio, 'YYYY-MM-DD').toDate();
        // this.dateRange.to= moment(this.fechafinal, 'YYYY-MM-DD').toDate();
        this.dateInput = moment(this.fechainicio, 'YYYY-MM-DD').toDate()
        this.granServicioDePTWService.objetoPasosCompletados = doc.data().objetoPasosCompletados
    })
   }
 }


 calcularDiferenciaDias(fecha1: string, fecha2: string): number {
  const fechaInicio = moment(fecha1, 'YYYY-MM-DD');
  const fechaFin = moment(fecha2, 'YYYY-MM-DD');
  return fechaInicio.diff(fechaFin, 'days');
}

 cargaempresas(){
  this.serviciodealertasyloaders.presentLoading("Cargando empresas...")
  this.empresas=[]
   firebase.firestore().collection("empresas").get().then((items)=>{
     items.forEach((doc)=>{
      this.empresas.push( { id:this.empresas.length-1 , name: doc.data().nombre, dominio: doc.data().dominio } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
     })
     
   }).then(()=>{
    this.serviciodealertasyloaders.cerrarmodal()
   })
 }

//  asignafechas(){
//   //  console.log(this.dateRange.from)
//   //  this.fechainicio = moment(this.dateRange.from ).format('YYYY-MM-DD');
//   //  this.fechafinal = moment(this.dateRange.from).add(7,'days').format('YYYY-MM-DD');

//   console.log("asignafechas activado")

//    if(this.horarioDeTrabajo == "AM"){
//     this.fechainicio = moment(this.dateInput).format('YYYY-MM-DD');
//     this.fechafinal = moment(this.dateInput).add(7,'days').format('YYYY-MM-DD');
//    }else
//    if(this.horarioDeTrabajo == "PM"){
//     this.fechainicio = moment(this.dateInput).format('YYYY-MM-DD');
//     this.fechafinal = moment(this.dateInput).add(8,'days').format('YYYY-MM-DD');
//    }
   
//  }

 asignafechas(){


   if(this.diasSolicitados>7){this.diasSolicitados=7}else
   if(this.diasSolicitados<1){this.diasSolicitados=1}

   if(this.horarioDeTrabajo == "AM"){
    this.fechainicio = moment(this.dateInput).format('YYYY-MM-DD');
    this.fechafinal = moment(this.dateInput).add(this.diasSolicitados,'days').format('YYYY-MM-DD');
   }else
   if(this.horarioDeTrabajo == "PM"){
    this.fechainicio = moment(this.dateInput).format('YYYY-MM-DD');
    this.fechafinal = moment(this.dateInput).add(this.diasSolicitados+1,'days').format('YYYY-MM-DD');
   }
   
 }



 borraPozoSeleccionado(){
  this.pozoSeleccionado=''
 } 

 seleccionaRegional(){
   this.pozos=[];
   this.cargaLocacionesDeRegional(this.cuenca,()=>{
   })
 }

 pozoChange(event: {
   component: IonicSelectableComponent,
   value: any
 }) {
   // console.log('pozo:', event.value);
   this.pozoSeleccionado=event.value.name;
 }

 empresaChange(event: {
  component: IonicSelectableComponent,
  value: any
  }) {
    this.empresaSeleccionada=event.value.name;
  }
 
 seleccionaUnidad(){
   this.pozos=[];
   this.pozoSeleccionado=''
   this.cuenca=''
 }

 cargaLocacionesDeRegional(cuenca,callback){
  this.serviciodealertasyloaders.presentLoading("cargando locaciones")
  this.pozos=[];

   let query = firebase.firestore().collection("locaciones").where("regional","==",cuenca)
   query.get().then((items)=>{
     items.forEach((item)=>{
       this.pozos.push({id:this.pozos.length, name:item.data().name, regional:item.data().regional})
     })
   }).then(()=>{
     this.serviciodealertasyloaders.loadingController.dismiss()
     callback()
   })
 }

 continuar(){

  if(this.cuenca !='' && this.pozoSeleccionado!=''&& this.horarioDeTrabajo!='' && this.fechainicio!=''&&this.fechafinal!='' && this.solicitanteGTE!=''){
    this.granServicioDePTWService.objetoPasosCompletados.paso1='ok'
    if(this.granServicioDePTWService.solicitudEsNueva==true){
      this.nuevopermiso()
     }else
     if(this.granServicioDePTWService.solicitudEsNueva==false){
       this.update()
     }
  }else
  if(this.cuenca =='' || this.pozoSeleccionado ==''|| this.horarioDeTrabajo =='' || this.fechainicio==''||this.fechafinal==''||this.solicitanteGTE ==''){
    this.serviciodealertasyloaders.alerta("Campos incompletos","verifique que no existan campos sin diligenciar para continuar ")
  }

   
 }

 nuevopermiso() {
   this.serviciodealertasyloaders.presentLoading("Creando solicitud")

   firebase.firestore().collection("ptws").add({
     solicitante: firebase.auth().currentUser.email,
     solicitanteGTE:this.solicitanteGTE,
     empresa:this.empresaSeleccionada,
     nombreSolicitante:firebase.auth().currentUser.displayName,
     fechasolicitud: moment().format('YYYY-MM-DD'),
     horarioDeTrabajo:this.horarioDeTrabajo,
     fechainicio:this.fechainicio,
     fechafinal:this.fechafinal,
     cuenca:this.cuenca,
     pozoSeleccionado:this.pozoSeleccionado,
     unidadDeNegocio:'',
     descripcion:'',
     arrayDeEmpleados:[],
     status:"En diligenciamiento",
     objetoPasosCompletados:{paso1:'ok',paso2:'',paso3:'',paso3A:'',paso4:'',paso5:'',paso6:'',paso7:'',paso8:''},
      dictamenAutAislante:{vistobueno:false,comentario:''},
      dictamenAutElectrica:{vistobueno:false,comentario:''},
      dictamenAutHSE:{vistobueno:false,comentario:''},
      dictamenAutAmbiental:{vistobueno:false,comentario:''},
      dictamenAutArea:{vistobueno:false,comentario:''},
      dictamenAutAreaLocal:{vistobueno:false,comentario:''},
      dictamenGerenteCampo:{vistobueno:false,comentario:''},
      requiereAutoridadAislante:false,
      requiereAutoridadElectrica:false,
      requiereGerenteCampo:false,
      arrayActividadesPTW:this.arrayActividadesPTW

   }).then(async(doc)=>{
     firebase.firestore().collection("ptws").doc(doc.id).update({ticket: doc.id.substring(doc.id.length - 6)}).then(()=>{
       this.granServicioDePTWService.idSolicitud = doc.id
       this.serviciodealertasyloaders.loadingController.dismiss()
       this.serviciodealertasyloaders.presentToast("¡Solicitud creada! Continúe con el resto de pasos")
       this.granServicioDePTWService.solicitudEsNueva=false;
     
       this.navegar("/paso2page")
     }).catch((err)=>{
       console.log(err)
     })
     
   }).catch((err)=>{
     console.log(err)
   })
 }


 update(){

  console.log("pozoSeleccionado en update()" + this.pozoSeleccionado)

   firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update({
    fechaUltimaEdicion: moment().format('YYYY-MM-DD'),
    horarioDeTrabajo:this.horarioDeTrabajo,
    fechainicio:this.fechainicio,
    fechafinal:this.fechafinal,
    cuenca:this.cuenca,
    pozoSeleccionado:this.pozoSeleccionado,
    solicitanteGTE:this.solicitanteGTE,
    empresa:this.empresaSeleccionada,
    "objetoPasosCompletados.paso1":"ok" //---->poniendo entre comillas y con dot notation podemos actualizar valores dentro de objetos
   }).then(()=>{
    this.serviciodealertasyloaders.presentToast("¡Cambios guardados! Continúe con el resto de pasos")
    this.navegar("/paso2page")
    
   }).catch((err)=>{
     this.serviciodealertasyloaders.alerta("Error",err)
   })
 }


 


 navegar(entrada){
   this.router.navigateByUrl(entrada);
} 

volveramenu(){
  this.navegar("/menu")
 }




}
